import { Component, input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-webinar-banner',
    standalone: true,
    imports: [NgClass],
    templateUrl: './webinar-banner.component.html',
    styleUrl: './webinar-banner.component.scss'
})
export class WebinarBannerComponent {
  shouldStack = input<boolean>(false);
}
